const PROPERTY_TYPES = [
	'5 to 8 story condos',
	'Condo',
	'Coop',
	'Manufactured Home',
	'Multi-unit',
	'Single Family',
	'Townhome'
];

export default PROPERTY_TYPES;
